export default __webpack_public_path__ + "3c0bfecb85a1d3fa6a2ddb2dc8e5007d.svg";